<template>
    <div class="grid grid-cols-2 gap-6 ">
        <figure
            v-for="(building, index) in buildings"
            :key="index"
            :class="[
                'relative  p-8 mt-16 bg-output-gray-200',
                {
                    'col-span-2': buildings.length === 1
                }
            ]"
        >
            <img
                :src="
                    building.image !== null
                        ? building.image
                        : '/placeholder.webp'
                "
                :class="[
                    'absolute w-2/12 h-32 left-4 -top-16',
                    {
                        'w-2/12': buildings.length === 1,
                        'w-4/12': buildings.length > 1
                    }
                ]"
            />
            <div
                :class="[
                    'grid justify-center  gap-2 mt-10',
                    {
                        'grid-cols-3': buildings.length === 1,
                        'grid-cols-1': buildings.length > 1
                    }
                ]"
            >
                <div
                    :class="[
                        {
                            'col-span-2': buildings.length === 1
                        }
                    ]"
                >
                    <h4 class="inline text-lg font-medium text-output-primary">
                        Adresse :
                    </h4>
                    <p class="inline text-lg">
                        {{ building.address }}
                    </p>
                </div>
                <div>
                    <h4 class="inline text-lg font-medium text-output-primary">
                        Superficie(㎡) :
                    </h4>
                    <p class="inline text-lg">
                        {{ building.Superficie }}
                    </p>
                </div>
                <div>
                    <h4 class="inline text-lg font-medium text-output-primary">
                        Achat / location:
                    </h4>
                    <p class="inline text-lg">
                        {{ building.isBuying }}
                    </p>
                </div>
                <div>
                    <h4 class="inline text-lg font-medium text-output-primary">
                        Prix / Rent (HT):
                    </h4>
                    <p class="inline text-lg">
                        {{ cost(building) }}
                    </p>
                </div>
                <div>
                    <h4 class="inline text-lg font-medium text-output-primary">
                        Acquisition FDC:
                    </h4>
                    <p class="inline text-lg">
                        {{ building.FCD === true ? "Oui" : "Non" }}
                    </p>
                </div>
                <div :class="[{ 'col-span-2': buildings.length === 1 }]">
                    <h4 class="inline text-lg font-medium text-output-primary">
                        Nature
                    </h4>
                    <p class="inline text-lg">
                        {{ buildingType(building.buildingType) }}
                    </p>
                </div>
                <div :class="[{ 'col-span-2': buildings.length === 1 }]">
                    <h4 class="inline text-lg font-medium text-output-primary">
                        Montant de construction / Aménagement (HT):
                    </h4>
                    <p class="inline text-lg">
                        {{ constructionCost(building) + " DH" }}
                    </p>
                </div>
            </div>
        </figure>
    </div>
</template>

<script>
import { OutputHelpers } from "@/mixins/OutputMixin.js";
import { formatPrice } from "../../../utils";

export default {
    mixins: [OutputHelpers],

    props: {
        buildings: {
            type: Array,
            required: true
        }
    },
    methods: {
        cost(building) {
            switch (building.isBuying) {
                case "Location":
                    return formatPrice(building.rent) + " DH";
                case "Achat":
                    return formatPrice(building.price) + " DH";
                case "Leasing":
                    return formatPrice(building.price) + " DH";
            }
        },
        buildingType(type) {
            if (type === "terrain") return "Terrain";
            if (type === "local_pro") return "Local Commercial";
            return "Plateaux de bureaux";
        },
        constructionCost(building) {
            if (building.buildingType !== "terrain") {
                return formatPrice(
                    building.constructionTotal === null
                        ? 0
                        : building.constructionTotal
                );
            } else {
                if (building.constructionEntry === "quantity") {
                    let total = 0;
                    for (const constructionType in building.constructionCost) {
                        if (
                            building.constructionCosts[constructionType]
                                .price !== null &&
                            building.constructionCosts[constructionType]
                                .surface !== null
                        ) {
                            total +=
                                building.constructionCosts[constructionType]
                                    .price *
                                building.constructionCosts[constructionType]
                                    .surface;
                        }
                    }
                    return formatPrice(total);
                }
                return formatPrice(building.constructionTotal);
            }
        }
    }
};
</script>

<style></style>
